import Navigation from './pages/Navigation/Navigation'
import './App.css'
import { AuthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import AutoRedirectToLogin from './AutoRedirectToLogin';

function App() {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <AutoRedirectToLogin />;
  }
  return (
    <AuthenticatedTemplate>
      <Navigation />
    </AuthenticatedTemplate>
  );
}

export default App;
